import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface ICtaBarProps extends IBaseElementProps {
	image?: IImage;
	name?: string;
	position?: string;
	heading?: string;
	text?: string;
	link?: ILink;
	style?: 'default' | 'inline';
}

/**
 * CTA Bar
 * @block
 * @requiresHooks
 * @icon editor-insertmore
 */
const CtaBar: React.FC<ICtaBarProps> = ({
	className,
	classNames = [],
	image,
	name,
	position,
	heading,
	text,
	link,
	style = 'default',
}) => (
	<div
		className={
			className || cn('cta-bar', `cta-bar--${style}`, ...classNames)
		}
	>
		<div className="cta-bar__image-wrapper">
			{image && <Image {...image} className="cta-bar__image" />}
			{name && <div className="cta-bar__name">{name}</div>}
			{position && <div className="cta-bar__position">{position}</div>}
		</div>

		<div className="cta-bar__content">
			{heading && <h2 className="cta-bar__heading">{heading}</h2>}
			{text && <div className="cta-bar__text">{text}</div>}
			{link?.label && (
				<Button
					{...link}
					className="cta-bar__button btn btn-primary btn-lg"
				/>
			)}
		</div>
	</div>
);

export default CtaBar;
